import React, { useState, useEffect, useMemo, memo, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Spinner, Modal, Form, ButtonGroup, Button } from 'react-bootstrap';
import close from '../Asset/close.svg';
import default_img from '../Asset/default_img.webp';
import * as moment from 'moment';
import Alert from './Alert';
import Table from './tables/srlistTable';
import { useTable, useGlobalFilter, useAsyncDebounce, usePagination, useSortBy } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faArrowDownShortWide, faArrowUpWideShort, faImages, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import { FileUploader } from "react-drag-drop-files";
// import { read, utils, writeFileXLSX } from 'xlsx';
import writeFileXLSX from 'xlsx';
import { environment } from './functions/environment';


let filesToUpload = [];
let validFiles = [];

function ServiceRequestList() {
  const filRef = useRef(null);
  let [fileErr, setFileErr] = useState("");
  var date = new Date();
  var dd = String(date.getDate()).padStart(2, '0');
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var yyyy = date.getFullYear();
  const [today, setToday] = useState(yyyy + "-" + mm + "-" + dd);
  // console.log(today)
  let [tdate, setTdate] = useState("");
  let [sessOut, setSessOut] = useState(false);
  let [alert, setAlert] = useState({
    msg: "",
    status: false
  });
  let [tableHis, setTableHis] = useState({
    page: "",
    key: ""
  })
  let [fileUp, setFileUP] = useState(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showDocs, setShowDocs] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setFileErr("");
    filesToUpload = [];
    validFiles = [];
    setFileUP(false);
    // setSrErrorMsg({});
  }
  const handleShow = () => {
    getTodayDate();
    setShow2(true);
    getAssetList();
  }
  const handleShowDocClose = () => {
    setShowDocs(false);
    setImgUrl(default_img);
  };
  const handleClose = () => {
    setErrorMsg({});
    setShow(false);
  }
  const handleClose1 = () => setShow1(false);
  const fileTypes = ["PDF"];
  const [name, setName] = useState("")
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  //for filter
  const [filterShow, setFilterShow] = useState(false);
  const handleFilterShow = useCallback(() => {
    setFilterShow(() => true);
  }, [])
  const handleFilterClose = () => {
    setFilterShow(false);
    // setFilter({
    //   fromDate: "",
    //   toDate: "",
    //   status: ""
    // })
  }
  const resetFilter = () => {
    setFilter({
      fromDate: "",
      toDate: "",
      status: ""
    });
    setFilterShow(false);
    getSRAccontData({
      startDate: "",
      endDate: "",
      status: ""
    });
  }
  const [filterError, setFilterErrr] = useState({});


  let userObj = sessionStorage.getItem("userInfo") ? getUserInfo() : {};
  let [editData, setEditData] = useState({
    serviceReqID: null,
    accountID: "",
    assetID: "",
    siteID: null,
    branchID: null,
    serviceReqType: "",
    createdDateTime: "",
    srCloseDateTime: "",
    sfdcSrID: "",
    status: "",
    commentsBycreator: "",
    commentsByApprover: "",
    isActive: true,
    subject: "",
    equipmentUnderOperationalCond: "",
    assetLocationLandmark: ""
  });

  let [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
    status: ""
  });

  let [errorMsg, setErrorMsg] = useState({});
  function SRvalidate() {
    // console.log("Hello");
    let errror = {};
    if (editData.srCloseDateTime == "" || editData.srCloseDateTime == null) {
      errror.srCloseDateTime = "This field is required";
    }
    if (editData.sfdcSrID == "" || editData.sfdcSrID == null) {
      errror.sfdcSrID = "This field is required";
    }
    else if (editData.sfdcSrID !="" && stringValidation(editData.sfdcSrID)) {
      errror.sfdcSrID = "Enter valid value.";
    }
    else if (editData.sfdcSrID.length > 25) {
      errror.sfdcSrID = "Exceeded 25 characters limit";
    }
    if (editData.status == "") {
      errror.status = "This field is required";
    }

    if (editData.assetLocationLandmark !="" && stringValidation(editData.assetLocationLandmark)) {
      errror.assetLocationLandmark = "Enter valid value.";
    }
    if (editData.commentsByApprover !="" && stringValidation(editData.commentsByApprover)) {
      errror.commentsByApprover = "Enter valid value.";
    }
    setErrorMsg(errror);
    if (Object.keys(errror).length == 0) {
      updateSRData();
    }
  }

  function getTodayDate() {
    let date = new Date();
    let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    var dd = String(date.getDate()).padStart(2, '0');
    var mmm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    let today = yyyy + "-" + mmm + "-" + dd;
    let time = hh + ":" + mm + ":" + ss;
    setTdate(today + " " + time);
  }
  const showEditData = useCallback((e) => {
    // console.log(e.target.id);
    //getSrById(e.target.id);

    fetch(environment.baseUrl + "sr/" + e.target.id, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code == 200) {
            let obj = resp.data.result[0]
            let reqObj = {
              serviceReqID: obj.serviceReqID,
              assetID: obj.assetID,
              siteID: obj.siteID,
              branchID: obj.branchID,
              commentsBycreator: obj.commentsBycreator,
              accountID: obj.accountID,
              serviceReqType: obj.serviceReqType,
              sfdcSrID: obj.sfdcSrID ? obj.sfdcSrID : "",
              commentsByApprover: obj.commentsByApprover ? obj.commentsByApprover : "",
              status: obj.status,
              isActive: true,
              createdDateTime: obj.createdDateTime,
              updatedDateTime: obj.updatedDateTime,
              srCloseDateTime: obj.srCloseDateTime ? obj.srCloseDateTime : "",
              userID: obj.userID,
              sharedLink: obj.sharedLink,
              siteName: obj.siteName,
              accountName: obj.accountName,
              subject: obj.subject,
              equipmentUnderOperationalCond: obj.equipmentUnderOperationalCond,
              assetLocationLandmark: obj.assetLocationLandmark
            }
            //setEditData(obj);
            setEditData((ps) => reqObj);
            //console.log("edit status", obj.status)
            if (obj.status == 'Closed') {
              //setLoader(true);
              setShow1((ps) => true);
            }
            else {
              //setLoader(true);
              setShow((ps) => true);
            }
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
        })

      })
  }, [])
  function getSrById(srId) {
    fetch(environment.baseUrl + "sr/" + srId, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code == 200) {
            let obj = resp.data.result[0]
            //setEditData(obj);
            setEditData({
              serviceReqID: obj.serviceReqID,
              assetID: obj.assetID,
              siteID: obj.siteID,
              branchID: obj.branchID,
              commentsBycreator: obj.commentsBycreator,
              accountID: obj.accountID,
              serviceReqType: obj.serviceReqType,
              sfdcSrID: obj.sfdcSrID ? obj.sfdcSrID : "",
              commentsByApprover: obj.commentsByApprover ? obj.commentsByApprover : "",
              status: obj.status,
              isActive: true,
              createdDateTime: obj.createdDateTime,
              updatedDateTime: obj.updatedDateTime,
              srCloseDateTime: obj.srCloseDateTime ? obj.srCloseDateTime : "",
              userID: obj.userID,
              sharedLink: obj.sharedLink,
              siteName: obj.siteName,
              accountName: obj.accountName,
            })
            //console.log("edit status", obj.status)
            if (obj.status == 'Closed') {
              //setLoader(true);
              setShow1(true);
            }
            else {
              //setLoader(true);
              setShow(true);
            }
            //setLoader(false);
            if (userObj.userType == 'admin') {
              getSRAccontData({
                startDate: filter.fromDate,
                endDate: filter.toDate,
                status: filter.status
              });
            }
            else {
              getSRByUser();
            }
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
        })

      })
  }
  let [serviRequest, setServiceRequest] = useState([]);

  function validateSRFilter() {
    let error = {};
    if (filter.fromDate == "" && filter.toDate != "") {
      error.startDate = "for date range this field is required";
    }
    if (filter.fromDate != "" && filter.toDate == "") {
      error.endDate = "for date range this field is required";
    }
    setFilterErrr(error);
    if (Object.keys(error).length == 0) {
      getSRAccontData({
        startDate: filter.fromDate,
        endDate: filter.toDate,
        status: filter.status
      });
    }
  }

  function getSRAccontData(req) {
    fetch(environment.baseUrl + "getSRs?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(req)
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code == 200) {
            setServiceRequest(resp.data.result);
            setFilterShow(false);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            setServiceRequest([]);
          }
        })
      })
  }

  function getSRByUser() {
    fetch(environment.baseUrl + "getSRbyUser?", {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          if (resp.code == 200) {
            setServiceRequest(resp.data.result);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            setServiceRequest([]);
          }
        })
      })
  }


  useEffect(() => {
    let abortController = new AbortController();
    //setSheetData(getData2())
    if (userObj.userType == 'admin') {
      getSRAccontData({
        startDate: filter.fromDate,
        endDate: filter.toDate,
        status: filter.status
      });
    }
    else {
      getSRByUser();
    }
    return () => {
      abortController.abort();
    }
  }, []);

  const downloadReport = () => {
    // console.log(sheetData);
    let requiredObj = [];
    serviRequest.forEach(element => {
      requiredObj.push({
        "SR ID": element.serviceReqID,
        "Account Name": element.accountName,
        "Site": element.siteName,
        "Asset ID": element.assetID,
        "Type": element.serviceReqType,
        "Status": element.status,
        "Subject": element.subject,
        "Description": element.commentsBycreator,
        "Is Operational": element.equipmentUnderOperationalCond,
        "Landmark": element.assetLocationLandmark,
        "Created Date & Time": simpleTimeConvert(element.createdDateTime),
        "Closed Date & Time": simpleTimeConvert(element.srCloseDateTime),
        "SFDC SR ID": element.sfdcSrID,
        "Approver comments": element.commentsByApprover,
      })
    })
    var wb = writeFileXLSX.utils.book_new(),
      ws = writeFileXLSX.utils.json_to_sheet(requiredObj);
    writeFileXLSX.utils.book_append_sheet(wb, ws, "MyShhet1");
    writeFileXLSX.writeFile(wb, "MyExcel.xlsx");
  };

  function updateSRData() {
    handleClose();
    fetch(environment.baseUrl + 'updateSR', {
      method: "PUT",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(editData)
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        //console.log("edited data", resp);
        if (userObj.userType == 'admin') {
          getSRAccontData({
            startDate: filter.fromDate,
            endDate: filter.toDate,
            status: filter.status
          });
        }
        else {
          getSRByUser();
        }
        setAlert({
          msg: resp.msg,
          status: true
        });

        setEditData({
          serviceReqID: null,
          accountName: "",
          accountID: "",
          assetID: "",
          siteID: null,
          branchID: null,
          serviceReqType: "",
          createdDateTime: null,
          srClsoeDateTime: "",
          sfdcSrID: "",
          status: "",
          commentsBycreator: "",
          commentsByApprover: "",
          isActive: true
        })
      })
    })


  }
  function getUpdatedSRData(e) {
    if (e.target.name == "srCloseDateTime") {
      let date = new Date();
      let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time = "T" + hh + ":" + mm + ":" + ss + ".000Z";
      //console.log("date&Time:",e.target.value+time);
      setEditData({ ...editData, [e.target.name]: e.target.value + time });
    }
    else {
      setEditData({ ...editData, [e.target.name]: e.target.value });
    }
  }

  function simpleTimeConvert(apiTime) {
    if (apiTime != null) {
      let yy = apiTime.slice(0, 4);
      let mm = apiTime.slice(5, 7);
      let dd = apiTime.slice(8, 10);
      let time = apiTime.slice(11, 16);
      return (dd + "-" + mm + "-" + yy + " " + time);
    }
    else {
      return ("NA");
    }
  }
  function convertTime(fulltime) {
    
    // let date = new Date(fulltime);
    // const local = moment.utc(date).local().format();
    if (fulltime != null) {
      let yy = fulltime.slice(0, 4);
      let mm = fulltime.slice(5, 7);
      let dd = fulltime.slice(8, 10);
      let time = fulltime.slice(11, 16);
      return (dd + "-" + mm + "-" + yy + " " + time);
    }
  }
  let [files, setFiles] = useState([]);
  function getFilesBySrID(srid) {
    fetch(environment.baseUrl + "getFilesBySrID", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        serviceReqID: srid
      })
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          if (resp.data.result.files.length) {
            setFiles(resp.data.result.files);
            setShowDocs(true);
          }
          else {
            setAlert({
              msg: "This service request not contain any attachment",
              status: true
            })
          }
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setFiles([]);
        }
      })
    })
  }
  let [imgUrl, setImgUrl] = useState(default_img);
  function showFileView(fid, fileType) {
    if (fileType == "application/pdf") {
      window.open("https://forkliftiotvn.azurewebsites.net/api/downloadFile/" + fid, '_blank');
    }
    else {
      setImgUrl("https://forkliftiotvn.azurewebsites.net/api/downloadFile/" + fid);
    }
  }
  function gotoSharedLink(link) {
    // console.log(link);
    if (link == null || link == "") {
      setAlert({
        msg: "No link available",
        status: true
      })
    }
    else if (link.includes("http")) {
      window.open(link, '_blank');
    }
    else {
      setAlert({
        msg: "Link not valid",
        status: true
      })
    }
  }

  function stringValidation(str) {
    if (str[0] == "=" || str[0] == "+" || str[0] == "-" || str[0] == "@") {
      return true;
    }
    else if (str.includes("0x09") || str.includes("0x0D")) {
      return true;
    }
    else {
      return false;
    }
  }

  let [srErrorMsg, setSrErrorMsg] = useState({});
  function saveSrValidate() {
    setSrErrorMsg({});
    // console.log("formdatavalidate", sr)
    let errror = {};
    if (sr.subject == "") {
      errror.subject = "This field is required";//Select Acoount"
    }
    else if (sr.subject != "" && stringValidation(sr.subject)) {
      errror.subject = "Enter valid value.";
    }
    else if (sr.subject.length > 50) {
      errror.subject = "Exceeded 25 characters limit";//Select Acoount"
    }
    if (sr.commentsByCreator == "") {
      errror.commentsByCreator = "This field is required";//Select Acoount"
    }
    else if (sr.commentsByCreator != "" && stringValidation(sr.commentsByCreator)) {
      errror.commentsByCreator = "Enter valid value.";
    }
    else if (sr.commentsByCreator.length > 50) {
      errror.commentsByCreator = "Exceeded 25 characters limit";//Select Acoount"
    }
    if (sr.assetID == "") {
      errror.assetID = "This field is required";//Select Acoount"
    }

    // if (sr.createdDateTime == "") {
    //     errror.createdDateTime = "This field is required";//Select Acoount"
    // }
    // if (sr.sharedLink == "") {
    //     errror.sharedLink = "This field is required";//Select Acoount"
    // }
    if (sr.equipmentUnderOperationalCond == "") {
      errror.equipmentUnderOperationalCond = "This field is required";//Select Acoount"
    }
    if (sr.srType == "") {
      errror.srType = "This field is required";//Select Acoount"
    }

    if (sr.sharedLink != "" && stringValidation(sr.sharedLink)) {
      errror.sharedLink = "Enter valid value.";
    }

    if (sr.assetLocationLandmark !="" && stringValidation(sr.assetLocationLandmark)) {
      errror.assetLocationLandmark = "Enter valid value.";
    }


    setSrErrorMsg(errror);
    // console.log(errror);
    if (Object.keys(errror).length == 0) {
      saveServiceRequestData();
    }
  }

  let [allAseet, setAllAsset] = useState([]);
  function getAssetList() {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        //console.log(res);
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  const [uploadedFiles, setUploadedFiles] = useState([]);

  let [sr, setSr] = useState({
    assetID: "",
    commentsByCreator: "",
    createdDateTime: "",
    isActive: true,
    sharedLink: "",
    srType: "",
    status: "Open",
    subject: "",
    equipmentUnderOperationalCond: "",
    assetLocationLandmark: ""
  })
  function getSrData(e) {
    setSr({ ...sr, [e.target.name]: e.target.value });
  }
  function saveServiceRequestData() {
    fetch(environment.baseUrl + "createSR", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        accountID: userObj.accountID,
        addRequestID: filesToUpload.length ? filesToUpload : [],
        assetID: sr.assetID,
        branchID: userObj.branchID,
        commentsByCreator: sr.commentsByCreator,
        isActive: true,
        remark: "",
        sfdcSrID: "",
        sharedLink: sr.sharedLink,
        siteID: userObj.siteID,
        srType: sr.srType,
        status: "Open",
        subject: sr.subject,
        equipmentUnderOperationalCond: sr.equipmentUnderOperationalCond,
        assetLocationLandmark: sr.assetLocationLandmark,
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          getSRByUser();
        }
        handleClose2();
        setAlert({
          msg: res.msg,
          status: true
        });
        setSr({
          accountID: "",
          commentsByCreator: "",
          createdDateTime: "",
          isActive: true,
          sharedLink: "",
          srType: "",
          status: "Open",
          subject: "",
          equipmentUnderOperationalCond: "",
          assetLocationLandmark: ""
        });
        getSRByUser();
      })
    })

  }

  function validateFiles(files) {
    validFiles = [];
    setFileErr("");
    let status = false;
    let allowExt = ['pdf', 'jpg', 'jpeg', 'png'];
    for (let index = 0; index < files.length; index++) {
      let nameArr = (files[index].name).split(".");
      if (nameArr.length == 2 && allowExt.indexOf(nameArr[1]) > -1 && nameArr[0] != "") {
        status = true;
      }
      else {
        filRef.current.value = "";
        status = false;
        break;
      }

      if (index === (files.length) - 1 && status) {
        validFiles = files;
      }
    }
    setFileErr(status ? "" : "Only file with extension 'pdf', 'jpg', 'jpeg', 'png' are allowed");
  }

  function uploadFile() {
    filesToUpload = [];
    if (validFiles.length) {
      setFileUP(true);
      setFileErr("");
    }
    else {
      setFileErr("Select file first.");
      setFileUP(false);
    }

    // for (let index = 0; index < (e.target.files).length; index++) {
    for (let index = 0; index < validFiles.length; index++) {
      let formData = new FormData();
      formData.append("file", validFiles[index]);
      // formData.append("file", e.target.files[index]);
      fetch("https://forkliftiotvn.azurewebsites.net/api/fileUpload", {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + userObj.token,
        },
        body: formData
      }).then((result) => {
        result.json().then((res) => {
          if (res.code === 200) {
            filesToUpload.push(res.data.result.fileID);
            if (index === validFiles.length - 1) {
              setFileUP(false);
              validFiles = [];
            }
          }
        })
      });
    }
  }
  // console.log("filesToUpload", filesToUpload);

  // console.log("uploadedFiles", uploadedFiles);




  //for react-table
  const columns = useMemo(
    () => [
      {
        Header: 'Service Req. ID ',
        accessor: 'serviceReqID', // accessor is the "key" in the data
      },
      {
        Header: 'Account Name ',
        accessor: 'accountName', // accessor is the "key" in the data
      },
      {
        Header: 'Site ',
        accessor: 'siteName',
      },
      {
        Header: 'Equipment ',
        accessor: 'assetID',
      },
      {
        Header: 'SR Type ',
        accessor: 'serviceReqType',
      },
      {
        Header: 'Status ',
        accessor: 'status',
      },
      {
        Header: 'Subject ',
        accessor: 'subject',
      },
      {
        Header: 'Description ',
        accessor: 'commentsBycreator',
      },
      {
        Header: 'Landmark ',
        accessor: 'assetLocationLandmark',
      },
      {
        Header: 'Is Operational ',
        accessor: 'equipmentUnderOperationalCond',
      },
      {
        Header: 'SR Created Date & Time ',
        accessor: 'createdDateTime',
      },
      {
        Header: 'SR Closed Date & Time ',
        accessor: 'srCloseDateTime',
      },
      {
        Header: 'SFDC SR ID ',
        accessor: 'sfdcSrID',
      },
      {
        Header: 'Comments By Approver ',
        accessor: 'commentsByApprover',
      },
      {
        Header: 'Attachment ',
        accessor: 'document',
      },
      {
        Header: 'Shared Link ',
        accessor: 'sharedLink',
      },
      {
        Header: 'Action ',
        accessor: 'action',
      },
    ],
    []
  )
  const userColumns = useMemo(
    () => [
      {
        Header: 'Service Req. ID ',
        accessor: 'serviceReqID', // accessor is the "key" in the data
      },
      {
        Header: 'Account Name ',
        accessor: 'accountName',
      },
      {
        Header: 'Site ',
        accessor: 'siteName',
      },
      {
        Header: 'Equipment ',
        accessor: 'assetID',
      },
      {
        Header: 'SR Type ',
        accessor: 'serviceReqType',
      },
      {
        Header: 'Status ',
        accessor: 'status',
      },
      {
        Header: 'Subject ',
        accessor: 'subject',
      },
      {
        Header: 'Description ',
        accessor: 'commentsBycreator',
      },
      {
        Header: 'Landmark ',
        accessor: 'assetLocationLandmark',
      },
      {
        Header: 'Is Operational ',
        accessor: 'equipmentUnderOperationalCond',
      },
      {
        Header: 'SR Created Date & Time ',
        accessor: 'createdDateTime',
      },
      {
        Header: 'SR Closed Date & Time ',
        accessor: 'srCloseDateTime',
      },
      {
        Header: 'SFDC SR ID ',
        accessor: 'sfdcSrID',
      },
      {
        Header: 'Comments By Approver ',
        accessor: 'commentsByApprover',
      },
      {
        Header: 'Attachment ',
        accessor: 'document',
      },
      {
        Header: 'Shared Link ',
        accessor: 'sharedLink',
      },
    ],
    []
  )

  function getFilterData(e) {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  }

  return (
    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <Alert obj={alert} />
      <h4 className='main-heading mt-2'>Service Request List</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;
        <i className='fa fa-angle-right'></i></Link>&nbsp; Service Request List</p>
      <div className="card-box-block mt-3" style={{ width: "100%" }}>
        {
          userObj.userType == "admin" ? ""
            : <div className="col-sm-8 right-col  text-end " style={{ float: "right" }}>
              <button className='btn-primary add-btn' onClick={handleShow}>Add <i className='fa fa-plus-circle ml-2'></i></button>
            </div>

        }

        <Table columns={userObj.userType == "admin" ? columns : userColumns}
          data={serviRequest}
          editFun={showEditData}
          docFun={getFilesBySrID}
          linkFun={gotoSharedLink}
          filterFun={handleFilterShow}
          downloadFun={downloadReport}
        />


      </div>

      <Modal show={show2} onHide={handleClose2} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>Add Service Request</Modal.Title>
          <button onClick={handleClose2} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          {/* <Form onSubmit={getFormData}> */}
          <div className="row">
            <div className="col-sm-12">
              <Form.Group className="mb-2" >
                <Form.Label>Subject<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control className="textbox-back" type='text' name='subject' placeholder='Enter Subject' onChange={getSrData} />
                <small className='red'>{srErrorMsg.subject}</small>
              </Form.Group>
            </div>
            <div className="col-sm-12">
              <Form.Group className="mb-2" >
                <Form.Label>Description<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control type="text" name='commentsByCreator' className="textbox-back" placeholder='Enter Description' onChange={getSrData} />

                <small className='red'>{srErrorMsg.commentsByCreator}</small>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Equipment ID<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Select as='select' name='assetID' className="textbox-back" onChange={getSrData}>
                  <option value="">Select Equipment ID</option>
                  {
                    allAseet.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
                <small className='red'>{srErrorMsg.assetID}</small>
              </Form.Group>


            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Service Request Type<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Select as="select" name='srType' className="textbox-back" onChange={getSrData}>
                  <option value="">Select Service Request Type</option>
                  <option value="Breakdown">Breakdown</option>
                  <option value="Service Request">Service Request</option>
                </Form.Select>
                <small className='red'>{srErrorMsg.srType}</small>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Created Date & Time</Form.Label>
                <Form.Control type='text' name='createDateTime' value={tdate} disabled />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Status</Form.Label>
                <Form.Control type="text" name='status' className="textbox-back" placeholder='Open' disabled onChange={getSrData} />

                {/* <small className='red'>{siteErrorMsg.startTime}</small> */}
              </Form.Group>
            </div>

            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Link to share</Form.Label>
                <Form.Control type="text" name='sharedLink' className="textbox-back" onChange={getSrData} placeholder='Enter Link' />
                <small className='red'>{srErrorMsg.sharedLink}</small>
              </Form.Group>
            </div>

            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Asset Location Landmark</Form.Label>
                <Form.Control type="text" name='assetLocationLandmark' className="textbox-back" onChange={getSrData} placeholder='Enter Landmark' />
                <small className='red'>{srErrorMsg.assetLocationLandmark}</small>
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group className="mb-3" >
                <Form.Label>Is Equipment under Operational Condition?<span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Select as="select" name='equipmentUnderOperationalCond' className="textbox-back" onChange={getSrData}>
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
                <small className='red'>{srErrorMsg.equipmentUnderOperationalCond}</small>
              </Form.Group>
            </div>


          </div>
          <div className="row">
            <div className="col-sm-9 pl-0 mb-2">
              <Form.Control
                type="file"
                name="file"
                id="file"
                className='textbox-back'
                onChange={(e) => { validateFiles(e.target.files) }}
                ref={filRef}
                // onChange={uploadFile}
                multiple
              />
            </div>
            <div className="col-sm-3 pr-0 mb-2">
              {fileUp ?
                <button className="btn confirm-btn float-end" type="button" disabled>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Uploding...
                </button>
                :
                <button className="btn btn-light lo-btn confirm-btn float-end" onClick={uploadFile}>
                  Upload
                </button>
              }
            </div>
            <small className='red'>{fileErr}</small>
          </div>
          <div className="row text-center mt-3">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose2}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="btn btn-light lo-btn confirm-btn float-start" onClick={saveSrValidate} disabled={fileUp}>
                Save
              </button>
            </div>
          </div>
          {/* </Form> */}
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} backdrop="static" size="lg" centered>
        <Modal.Header >
          <Modal.Title>Edit Service Request Details</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="row justify-content-center mt-1" >
            <Spinner animation="border" variant="primary" style={loader ? { display: "block" } : { display: "none" }} />
          </div>
          <div
            style={loader ? { display: "none" } : { display: "block" }}>
            <div className='row  ml-5'>
              <div className='col-sm-12 mb-3'>
                <label>Subject</label>
                <Form.Control type='text' placeholder='Subject' value={editData.subject} disabled />
              </div>
              <div className='col-sm-12 mb-3'>
                <label>Description</label>
                <Form.Control type='text' placeholder='Description' value={editData.commentsBycreator} disabled />
              </div>
              <div className='col-sm-4 mb-3'>
                <label>Account Name</label>
                <Form.Control type='text' placeholder='Account Name' value={editData.accountName} disabled />
              </div>
              <div className='col-sm-4'>
                <Form.Group className="mb-3" >
                  <label>Site</label>
                  <Form.Control type='text' placeholder='Site' value={editData.siteName} disabled />
                </Form.Group>
              </div>
              <div className='col-sm-4 '>
                <label>SR Type</label>
                <Form.Control type='text' placeholder='SR Type' value={editData.serviceReqType}
                  disabled />
              </div>
            </div>
            <div className='row ml-5'>
              <div className='col-sm-4'>
                <label>SR Created Date & Time</label>
                <Form.Control type='text' placeholder='SR Created Date' value={convertTime(editData.createdDateTime)}
                  disabled />
              </div>
              <div className="col-sm-4">
                <label>Asset Location Landmark</label>
                <Form.Control type="text" name='assetLocationLandmark' value={editData.assetLocationLandmark} onChange={getUpdatedSRData} />
                <small className='red'>{errorMsg.assetLocationLandmark}</small>
              </div>

              <div className="col-sm-4">
                <label>Is Equipment Operational ?</label>
                <Form.Select as="select" name='equipmentUnderOperationalCond' value={editData.equipmentUnderOperationalCond} disabled>
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
              </div>
            </div><br />
            <div className='row ml-5'>
              <div className='col-sm-4 mb-3 '>
                <label>SR Closed Date & Time<span style={{ color: "red" }}>*</span></label>
                <Form.Control type='date' min={moment().format('YYYY-MM-DD')} placeholder='SR Closed Date' name='srCloseDateTime'
                  onChange={getUpdatedSRData} />
                <small className='red'>{errorMsg.srCloseDateTime}</small>
              </div>
              <div className='col-sm-4 mb-3'>
                <label>SFDC SR ID<span style={{ color: "red" }}>*</span></label>
                <Form.Control type='text' placeholder='SFDC SR ID' name='sfdcSrID'
                  value={editData.sfdcSrID}
                  onChange={getUpdatedSRData}
                />
                <small className='red'>{errorMsg.sfdcSrID}</small>
              </div>
              <div className='col-sm-4 mb-3'>
                <label>Status</label>
                <Form.Select name='status' onChange={getUpdatedSRData} value={editData.status}>
                  <option value="Open">Open</option>
                  <option value="Closed">Closed</option>
                </Form.Select>
                <small className='red'>{errorMsg.status}</small>
              </div>
              <div className='col-sm-6'>
                <Form.Group>
                  <label>Comment By Approver</label>
                  <Form.Control type='text' placeholder='Comment By Approver' name='commentsByApprover'
                    value={editData.commentsByApprover}
                    onChange={getUpdatedSRData}
                  />
                </Form.Group>
                <small className='red'>{errorMsg.commentsByApprover}</small>
              </div>
            </div>
            <div className="row text-center mt-3">
              <div className="col-sm-6">
                <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose}>
                  Cancel
                </button>
              </div>
              <div className="col-sm-6">
                <button className="btn btn-light lo-btn confirm-btn float-start" onClick={SRvalidate}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </Modal.Body> </Modal>

      {/* ----------WHEN STATUS IS CLOSED */}
      <Modal show={show1} onHide={handleClose1} backdrop="static" centered>
        <Modal.Header  >
          <Modal.Title>Edit Service Request Details</Modal.Title>
          <button onClick={handleClose1} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <label>Service Request is already Closed!!!</label>
        </Modal.Body>
      </Modal>

      {/* for view documents */}
      <Modal show={showDocs} onHide={handleShowDocClose} backdrop="static" size="lg" centered>
        <Modal.Header  >
          <Modal.Title>View all attachment</Modal.Title>
          <button onClick={handleShowDocClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-sm-6">
              {
                files.map((item, index) =>
                  <div key={index} id={item.fileID} onClick={() => showFileView(item.fileID, item.fileType)} className="form-control mb-2 view-doc-btn">
                    {item.fileType == "application/pdf" ?
                      <span className='mr-2'><FontAwesomeIcon icon={faFilePdf} />&nbsp;</span>
                      :
                      <span className='mr-2'><FontAwesomeIcon icon={faImages} />&nbsp;</span>
                    }
                    {item.fileName}
                  </div>
                )
              }
            </div>
            <div className="col-sm-6">
              <img src={imgUrl} className="img-fluid" alt="..." />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* for view documents */}

      {/* for Filter */}
      <Modal show={filterShow} onHide={handleFilterClose} backdrop="static" size="lg" centered>
        <Modal.Header  >
          <Modal.Title>Filter</Modal.Title>
          <button onClick={handleFilterClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='logout-box'>
          <div className="row">
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <Form.Label>From Date</Form.Label>
                <Form.Control type='date' placeholder='fromDate' name='fromDate' value={filter.fromDate} max={today}
                  className="textbox-back" onChange={getFilterData} />
                <small className='red'>{filterError.startDate}</small>
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <Form.Label>To Date</Form.Label>
                <Form.Control type='date' placeholder='toDate' name='toDate' value={filter.toDate} min={filter.fromDate} max={today}
                  className="textbox-back" onChange={getFilterData} />
                <small className='red'>{filterError.endDate}</small>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <Form.Label>Status</Form.Label>
                <Form.Select as='select' name='status' className="textbox-back" value={filter.status} onChange={getFilterData}>
                  <option value="">Select Status</option>
                  <option value="open">Open</option>
                  <option value="closed">Closed</option>
                </Form.Select>
              </Form.Group>
            </div>
          </div>

          <div className="row text-center mt-4">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={resetFilter}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={validateSRFilter}>
                Apply
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      </div>
  )
}

export default ServiceRequestList
